import React, { createContext, useState, useEffect } from 'react';
import { useRouter } from 'next/router';

const NotificationContext = createContext();

const NotificationProvider = ({ children }) => {
    const [notification, setNotification] = useState([]);
    const [unreadNotification, setUnreadNotification] = useState(notification.length);

    const [toggleNotiBell, setToggleNotiBell] = useState(false); //to update notifiation bell everytime has action in notification
    const [viewAllNoti, setViewAllNoti] = useState(false); //whenever click View All in admin, it will trigger to managenotification tab

    const routers = useRouter();

    const header =
        routers.pathname === '/' ||
            routers.pathname === '/ManageCompany' ||
            routers.pathname === '/ManageRole'
            ? false : true;


    useEffect(() => {
        if (header) {
            fetch(`/bizcareui/api/ManageNotification/bellNotification`)
                .then((results) => results.json())
                .then((data) => {
                    const result = data.result;

                    if (result === 'Failed to load data' || result?.length === 0 || result === 'No Data Found') {
                        setUnreadNotification(0);
                        setNotification([]);
                    } else if (result?.length > 0) {
                        setUnreadNotification(result.length);
                        setNotification(result);
                    } else {
                        setUnreadNotification(0);
                        setNotification([]);
                    }
                });
        }
    }, [header, toggleNotiBell]);

    const removeNotification = (id) => {
        setNotification((prevNotifications) =>
            prevNotifications.filter((notification) => notification.id !== id)
        );
    };

    const authContextValue = {
        unreadNotification,
        setUnreadNotification,
        notification,
        setNotification,
        removeNotification,
        setToggleNotiBell,
        toggleNotiBell,
        setViewAllNoti,
        viewAllNoti
    };

    return (
        <NotificationContext.Provider value={authContextValue}>
            {children}
        </NotificationContext.Provider>
    );
};

export { NotificationContext, NotificationProvider };
